<quill-view
  [content]="content"
  #baseContainer
  [sanitize]="false"
  format="html"
  [class]="{
    'preview-border': hasBorder,
    'preview-max-width': !fullWidth,
  }"
  [modules]="quillModules"
></quill-view>
